(function(){
  var root = document.documentElement;
  var BRF_REV_COUNT = (window.brfRevCount == null ? null : window.brfRevCount);
  var phone = window.matchMedia('(max-width:767px)');
  var idle = window.requestIdleCallback || function(f){ return setTimeout(f, 60); };

  /* ---------- 1. Edge fades on every sideways-scrolling widget ----------
     2026-10-25 speed fix: the old scan read the size of every element on the page (thousands, every SVG icon
     included) and changed classes in between, which made the browser redo the page layout again and again.
     It ran on load, after every change to the page and every 4 seconds, which cost phones over a second of work.
     Now: SVGs, scripts and elements with no children are skipped, all sizes are read first and the classes
     written afterwards (one layout instead of hundreds), only newly added parts of the page are re-checked,
     and the full checks run when the browser is idle (after loading and after a resize). The fades look the same. */
  var SKIP = '[data-brf-nofx],.mini-cart,table,pre,.shopify-pc__prefs__dialog,#shopify-pc__banner,svg,script,style,noscript,template,iframe';
  function upd(el){
    var max = el.scrollWidth - el.clientWidth;
    var on = max > 2;
    el.classList.toggle('brf-fx', on);
    el.classList.toggle('brf-fx--s', on && el.scrollLeft > 2);
    el.classList.toggle('brf-fx--e', on && el.scrollLeft < max - 2);
  }
  function scan(start){
    start = start || document.body;
    if (!start || start.nodeType !== 1 || !start.isConnected) return;
    if (start !== document.body && start.closest(SKIP)) return;
    var w = document.createTreeWalker(start, NodeFilter.SHOW_ELEMENT, {acceptNode: function(n){
      if (n.matches(SKIP)) return NodeFilter.FILTER_REJECT;
      return (n.__brfHx || !n.childElementCount) ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    }});
    var list = [], n = (start.matches(SKIP) || start.__brfHx || !start.childElementCount) ? w.nextNode() : start;
    while (n) { list.push(n); n = w.nextNode(); }
    /* read pass (no writes, so the layout is worked out once) */
    var hits = [];
    for (var i = 0; i < list.length; i++) {
      var el = list[i], cw = el.clientWidth;
      if (cw < 120 || el.scrollWidth - cw <= 2) continue;
      var ox = getComputedStyle(el).overflowX;
      if (ox === 'auto' || ox === 'scroll') hits.push(el);
    }
    /* write pass */
    for (var j = 0; j < hits.length; j++) {
      (function(el){ el.__brfHx = 1; el.addEventListener('scroll', function(){ upd(el); }, {passive:true}); })(hits[j]);
    }
    for (var k = 0; k < hits.length; k++) upd(hits[k]);
  }
  function refresh(){
    var els = document.querySelectorAll('.brf-fx');
    for (var i = 0; i < els.length; i++) if (els[i].__brfHx) upd(els[i]);
  }
  var pending = [], scanT = null, fullT = null;
  function queueAdded(muts){
    for (var i = 0; i < muts.length; i++) {
      var a = muts[i].addedNodes;
      for (var j = 0; j < a.length; j++) if (a[j].nodeType === 1 && a[j].childElementCount) pending.push(a[j]);
    }
    if (!pending.length) return;
    clearTimeout(scanT);
    scanT = setTimeout(function(){
      var todo = pending; pending = [];
      idle(function(){
        for (var i = 0; i < todo.length; i++) {
          var t = todo[i], inside = false;
          for (var j = 0; j < todo.length; j++) if (j !== i && todo[j] !== t && todo[j].contains(t)) { inside = true; break; }
          if (!inside) scan(t);
        }
      });
    }, 300);
  }
  function queueFull(){ clearTimeout(fullT); fullT = setTimeout(function(){ idle(function(){ scan(); refresh(); }); }, 250); }
  idle(function(){ scan(); });
  window.addEventListener('load', function(){ idle(function(){ scan(); refresh(); }); });
  window.addEventListener('resize', function(){ queueFull(); refresh(); });
  new MutationObserver(queueAdded).observe(document.body, {childList:true, subtree:true});

  /* ---------- 2. Cookie banner: shorter wording + hide floating buttons while it is open ----------
     2026-10-25 speed fix: it used to re-check after every style change anywhere on the page (the homepage sets
     styles on every scroll frame); now it only reacts to changes in or around the cookie banner itself. */
  function consent(){
    var b = document.getElementById('shopify-pc__banner');
    var open = !!(b && b.getClientRects().length > 0 && getComputedStyle(b).display !== 'none' && getComputedStyle(b).visibility !== 'hidden');
    if (root.classList.contains('brf-consent-open') !== open) root.classList.toggle('brf-consent-open', open);
    if (!b) return;
    var p = b.querySelector('.shopify-pc__banner__body p');
    if (p && !p.__brfShort) {
      var a = p.querySelector('a');
      if (a) {
        p.__brfShort = 1;
        p.textContent = 'We and our partners use cookies to personalise your visit, show relevant ads and measure how our site is used – only if you accept. ';
        a.textContent = 'Privacy Policy';
        p.appendChild(a);
      }
    }
  }
  var cq = false;
  function queueConsent(){ if (cq) return; cq = true; requestAnimationFrame(function(){ cq = false; consent(); }); }
  /* read ids with getAttribute: a form's .id can be its <input name="id"> */
  function idOf(n){ return (n && n.getAttribute && n.getAttribute('id')) || ''; }
  function hasBanner(n){ return n.nodeType === 1 && (idOf(n) === 'shopify-pc__banner' || !!(n.querySelector && n.querySelector('#shopify-pc__banner'))); }
  function aboutBanner(m){
    if (m.type === 'childList') {
      for (var i = 0; i < m.addedNodes.length; i++) if (hasBanner(m.addedNodes[i])) return true;
      for (var j = 0; j < m.removedNodes.length; j++) if (hasBanner(m.removedNodes[j])) return true;
      return false;
    }
    var t = m.target;
    if (!t || t.nodeType !== 1) return false;
    if (idOf(t).indexOf('shopify-pc') === 0) return true;
    var b = document.getElementById('shopify-pc__banner');
    return !!(b && (t.contains(b) || b.contains(t)));
  }
  consent();
  new MutationObserver(function(muts){
    for (var i = 0; i < muts.length; i++) if (aboutBanner(muts[i])) { queueConsent(); return; }
  }).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['style','class']});

  /* ---------- 3. Chat button on phones: icon only, above the sticky bar, hidden with the banner/cart ----------
     2026-10-25 speed fix: checked every 0.6s for the first 15 seconds (while the chat loads), then every 3s. */
  var CHAT_CSS = ':host .activator-nudge{opacity:var(--brf-float-op,1)!important;visibility:var(--brf-float-vis,visible)!important;pointer-events:var(--brf-float-pe,auto)!important}'
    + '@media (max-width:767px){'
    + ':host .activator-nudge{right:14px!important;bottom:calc(14px + env(safe-area-inset-bottom) + var(--brf-float-lift,0px))!important;transform:none!important;'
    + 'transition:bottom .3s ease,opacity .2s ease!important}'
    + ':host .activator{width:52px!important;min-width:52px!important;height:52px!important;padding:0!important;border-radius:50%!important;justify-content:center!important;gap:0!important}'
    + ':host .activator__label{display:none!important}'
    + ':host .activator__icon{margin:0!important}}';
  function styleChat(node){
    var sr = node && node.shadowRoot; if (!sr) return;
    if (!sr.getElementById('brf-ux-chat')) { var st = document.createElement('style'); st.id = 'brf-ux-chat'; st.textContent = CHAT_CSS; sr.appendChild(st); }
    var all = sr.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) if (all[i].shadowRoot) styleChat(all[i]);
  }
  function chat(){ if (!document.hidden) styleChat(document.querySelector('shopify-chat')); }
  chat();
  var chatFast = setInterval(chat, 600);
  setTimeout(function(){ clearInterval(chatFast); setInterval(chat, 3000); }, 15000);
  document.addEventListener('visibilitychange', chat);
  document.addEventListener('click', function(){ setTimeout(chat, 50); setTimeout(chat, 400); }, true);

  /* ---------- 5. Product gallery on phones ---------- */
  if (!document.body.classList.contains('template-product')) return;
  function counter(){
    var prev = document.querySelector('.template-product .brf-garrow--prev'); if (!prev) return false;
    var gal = prev.closest('.product-gallery'); if (!gal) return false;
    var span = prev.querySelector('.brf-garrow__count');
    if (!span) { span = document.createElement('span'); span.className = 'brf-garrow__count'; prev.appendChild(span); }
    var ts = [].slice.call(gal.querySelectorAll('.product-gallery__thumbnail')).filter(function(t){ return t.offsetParent !== null; });
    var i = ts.findIndex(function(t){ return t.classList.contains('is-nav-selected'); });
    span.textContent = (i < 0 ? 1 : i + 1) + ' | ' + ts.length;
    prev.setAttribute('aria-label', 'Previous image (' + (i < 0 ? 1 : i + 1) + ' of ' + ts.length + ')');
    if (!gal.__brfObs) {
      gal.__brfObs = 1;
      new MutationObserver(function(){ counter(); }).observe(gal, {subtree:true, attributes:true, attributeFilter:['class']});
    }
    return true;
  }
  var cTries = 0, cT = setInterval(function(){ if (counter() || ++cTries > 30) clearInterval(cT); }, 400);

  /* ---------- 6. Reviews tab ---------- */
  function reviews(){
    var blk = document.querySelector('.product-block-list__item--reviews'); if (!blk || blk.__brfRev) return;
    var card = blk.querySelector(':scope > .card'); if (!card) return;
    var empty = BRF_REV_COUNT === 0;
    if (BRF_REV_COUNT === null) {
      var txt = blk.textContent || '';
      if (!/Be the first to write a review/i.test(txt)) return;
      empty = true;
    }
    if (!empty) { blk.__brfRev = 1; return; }
    blk.__brfRev = 1;
    var id = 'brf-rev-body';
    var sec = card.querySelector(':scope > .card__section'); if (sec) sec.id = id;
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'card__collapsible-button brf-rev-toggle';
    btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-controls', id);
    btn.innerHTML = '<span class="brf-rev-toggle__text"><span class="card__title heading h3">Customer Reviews</span><span class="brf-rev-toggle__sub">No reviews yet – be the first</span></span><span class="plus-button plus-button--large"></span>';
    btn.addEventListener('click', function(){
      var open = !blk.classList.contains('is-open');
      blk.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    card.insertBefore(btn, card.firstChild);
    blk.classList.add('brf-rev-min');
  }
  reviews(); var rT = 0, rI = setInterval(function(){ reviews(); if (++rT > 20) clearInterval(rI); }, 500);

  /* ---------- 5b. Swipe gallery on phones (replaces the fade) ---------- */
  function galleryInit(){
    var gal = document.querySelector('.template-product .product-gallery'); if (!gal || gal.__brfMg) return;
    var wrap = gal.querySelector('.product-gallery__carousel-wrapper');
    var car = gal.querySelector('.product-gallery__carousel');
    if (!wrap || !car) return;
    gal.__brfMg = 1;
    var mg = document.createElement('div'); mg.className = 'brf-mg';
    var track = document.createElement('ul'); track.className = 'brf-mg__track'; track.setAttribute('data-brf-nofx', '');
    track.setAttribute('aria-label', 'Product images'); mg.appendChild(track);
    wrap.insertBefore(mg, car);
    var ids = [], fromScroll = false, settleT = null;

    function thumbs(){ return [].slice.call(gal.querySelectorAll('.product-gallery__thumbnail')).filter(function(t){ return !t.classList.contains('is-filtered') && getComputedStyle(t).display !== 'none'; }); }
    function imgFor(id){
      var item = car.querySelector('.product-gallery__carousel-item[data-media-id="' + id + '"]');
      if (!item || item.getAttribute('data-media-type') !== 'image') return null;
      var im = item.querySelector('img.product-gallery__image'); if (!im) return null;
      var tpl = im.getAttribute('data-src') || '', alt = im.getAttribute('alt') || '';
      if (tpl.indexOf('{width}') === -1) return {src: im.currentSrc || im.src, alt: alt};
      return {src: tpl.replace('{width}', '800'), srcset: [500, 800, 1100].map(function(w){ return tpl.replace('{width}', w) + ' ' + w + 'w'; }).join(', '), alt: alt};
    }
    function current(){ var ts = thumbs(); for (var i = 0; i < ts.length; i++) if (ts[i].classList.contains('is-nav-selected')) return i; return 0; }
    function build(){
      var ts = thumbs(), next = ts.map(function(t){ return t.getAttribute('data-media-id'); });
      if (next.join() === ids.join()) return true;
      var data = next.map(imgFor);
      if (!data.length || data.some(function(d){ return !d; })) { gal.classList.remove('brf-mg-on'); ids = []; return false; }
      ids = next;
      track.innerHTML = data.map(function(d, i){
        return '<li class="brf-mg__slide" data-index="' + i + '"><img src="' + d.src + '"' + (d.srcset ? ' srcset="' + d.srcset + '" sizes="100vw"' : '') + ' alt="' + d.alt.replace(/"/g, '&quot;') + '"' + (i ? ' loading="lazy"' : '') + ' draggable="false"></li>';
      }).join('');
      gal.classList.add('brf-mg-on');
      track.style.scrollBehavior = 'auto'; track.scrollLeft = current() * track.clientWidth; track.style.scrollBehavior = '';
      return true;
    }
    /* swipe finished -> tell the theme which image is showing (keeps the counter, arrows and variant logic in step) */
    function settle(){
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)), ts = thumbs();
      if (ts[i] && !ts[i].classList.contains('is-nav-selected')) { fromScroll = true; ts[i].click(); setTimeout(function(){ fromScroll = false; }, 80); }
    }
    track.addEventListener('scroll', function(){ clearTimeout(settleT); settleT = setTimeout(settle, 140); }, {passive:true});
    /* arrows / colour choice -> glide to that image */
    new MutationObserver(function(){
      if (!build() || fromScroll) return;
      var x = current() * track.clientWidth;
      if (Math.abs(track.scrollLeft - x) > 2) track.scrollTo({left: x, behavior: 'smooth'});
    }).observe(gal.querySelector('.product-gallery__thumbnail-list') || gal, {subtree:true, attributes:true, attributeFilter:['class','style']});
    /* tap an image -> open the theme's zoom for it */
    track.addEventListener('click', function(e){
      var li = e.target.closest('.brf-mg__slide'); if (!li) return;
      var item = car.querySelector('.product-gallery__carousel-item[data-media-id="' + ids[+li.getAttribute('data-index')] + '"]');
      if (item) { var im = item.querySelector('img') || item; im.click(); }
    });
    build();
  }
  function galleryMode(){
    if (phone.matches) galleryInit();
    var gal = document.querySelector('.template-product .product-gallery');
    if (gal && gal.__brfMg) gal.classList.toggle('brf-mg-on', phone.matches && !!gal.querySelector('.brf-mg__slide'));
  }
  galleryMode();

  function relayout(){ try { window.dispatchEvent(new Event('resize')); } catch (e) {} }
  if (phone.addEventListener) phone.addEventListener('change', function(){ galleryMode(); relayout(); });
  window.addEventListener('load', relayout); setTimeout(relayout, 600);
})();
